export default [
   {
      id: 1,
      name: 'Persetujuan Bangunan Gedung',
      description: 'Permohonan izin baru untuk mendirikan bangunan.',
   },
   {
      id: 2,
      name: 'Perubahan Bangunan Gedung',
      description: 'Permohonan izin untuk merenovasi atau mengubah bangunan gedung.',
   },
   {
      id: 4,
      name: 'Sertifikat Laik Fungsi',
      description: 'Permohonan sertifikat kelaikan untuk bangunan eksisting (yang sudah berdiri).',
   },
   {
      id: 5,
      name: 'Sertifikat Laik Fungsi - Bangunan Baru',
      description: 'Permohonan sertifikat kelaikan yang terintegrasi/merupakan kelanjutan dari PBG.',
   },
]
